<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="grupo-produto vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('grupos-produto') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('vendas') : $t('promotor')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('produto') : $t('cadastros')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('grupos-produto') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !grupoIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: isVenda ? 'ven-produto-grupo-new' : 'pro-produto-grupo-new',
                                    })
                                "
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-two-quarters">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <!-- EMPRESAS -->
                        <div class="situacao-select column is-one-quarter">
                            <vss-select
                                ref="empresaSelect"
                                :searchable="false"
                                :options="empresas"
                                v-model="empresa"
                                class="no-clear"
                                title="empresa"
                                @input="updateEmpresa"
                                :height="40"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label> {{ $t('situacao') }} </label>
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="grupo-produto-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allgps"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete && !grupoIntegracao"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        @click="confirmExclusion(props.row)"
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        position="is-left"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: isVenda ? 'ven-produto-grupo-edit' : 'pro-produto-grupo-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'empresa'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}
                                    </b-tag>
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}
                                    </b-tag>
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import GrupoProdutoService from '@/services/GrupoProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            ['ven-produto-grupo-new', 'ven-produto-grupo-edit', 'pro-produto-grupo-new', 'pro-produto-grupo-edit'].includes(
                to.name
            )
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            grupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('GRUPOPRODUTO'),
            allgps: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new GrupoProdutoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'empresa', width: 500, sortable: false, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: '',
            changeThis: {},
            sort: {
                order: 'desc',
                column: 'DESCRICAO',
            },
            // @84624 - Criação da variável para verificar a origem da rota;
            // Esta variável é utilizada sempre que for necessário verificar se a origem é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            // @84624 - Criação de variáveis para listagem de empresas
            empresas: [{ id: 0, label: this.$t('todos').toUpperCase() }],
            empresa: { id: 0, label: this.$t('todos').toUpperCase() },
        };
    },
    created() {
        if (
            ['ven-produto-grupo-new', 'ven-produto-grupo-edit', 'pro-produto-grupo-new', 'pro-produto-grupo-edit'].includes(
                this.$route.name
            )
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-grupo')
            : this.hasPermissionAccess('promotor', 'cadastros', 'grupos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'grupos-produto' },
            });
        } else {
            this.loadEmpresas();
            this.carregarDados();
        }
    },
    methods: {
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            }
        },
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let empresa = '0, ';
            if (this.empresa && this.empresa.id >= 0) {
                empresa = this.empresa.id > 0 ? this.empresa.id : '0';
            } else {
                for (let e of this.empresas) {
                    if (e.id > 0) {
                        empresa += `${e.id}, `;
                    }
                }
                empresa = empresa.slice(0, -2);
            }
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.sort,
                    this.situacao.id,
                    empresa,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allgps = value;
                    this.isEmpty = this.allgps.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let gplist = [];
            if (body.content) {
                gplist = body.content.map((gp) => {
                    return {
                        id: gp.idgrupoproduto,
                        codigo: gp.idgrupoprodutoerp,
                        descricao: gp.descricao,
                        empresa:
                            gp.idempresa != 0
                                ? this.getEmpresa(gp.idempresa)
                                : this.$t('todos').toUpperCase(),
                        excluir: 'excluir-grupo-produto',
                        situacao: gp.situacao,
                    };
                });
            }
            return gplist;
        },
        getEmpresa(id) {
            for (let e of this.empresas) {
                if (id === e.id) {
                    return e.label;
                }
            }
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        updateEmpresa(t) {
            if (t) {
                this.empresa = t;
            } else {
                this.empresa = {};
            }
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.changeThis = item;
            this.$root.confirm({
                message:
                    item.situacao == 1
                        ? this.$t('msg-confirmacao-desativacao-n', { n: item.descricao })
                        : this.$t('msg-confirmacao-reativacao-n', { n: item.descricao }),
                onConfirm: this.changeSituacao,
                onCancel: (_) => {
                    this.changeThis = null;
                },
            });
        },
        changeSituacao() {
            let item = { idgrupoproduto: this.changeThis.id, situacao: this.changeThis.situacao };
            this.isLoading = true;
            this.service
                .changeSituacao(item)
                .then((_) => {
                    if (item.situacao == 1) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-desativar-grupoproduto');
                    } else {
                        this.$root.showMessage('success', 'msg-sucesso-ao-reativar-grupoproduto');
                    }
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao excluir grupo.', e);
                    if (item.situacao == 1) {
                        this.$root.showMessage('error', 'msg-erro-ao-desativar-grupoproduto');
                    } else {
                        this.$root.showMessage('error', 'msg-erro-ao-reativar-grupoproduto');
                    }
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.changeThis = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .grupo-produto .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .grupo-produto .search-and-filter {
        .search-bar {
            width: 80%;
        }
        .item-input {
            width: 19%;
        }
    }

    .grupo-produto .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
